import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
import { SearchService } from 'src/app/Services/search.service';

@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.css']
})
export class EmployeeListComponent implements OnInit {
  subscription: Subscription;
  @Output() searchItem: EventEmitter<any> = new EventEmitter();
  searchInvoiceAdapter: any;
  isShowAddEmp: boolean = true;
  constructor(private httpRequestService: HttpRequestService,
    private searchService: SearchService,
    private router: Router, private property: PropertiesService) {
    this.subscription = searchService.searchRefreshEvt$.subscribe(() => {
      this.getGridData();
    });
  }

  ngOnInit() {
    console.log(this.property.roleId);
    this.getGridData();
    if (this.property.roleId == this.property.DefaultRoleId || this.property.userId == 33 || this.property.userId == 2311 || this.property.userId == 2224) {
      this.isShowAddEmp = false;
    }
  }

  ngAfterViewInit(): void {
    this.getGridData();
  }

  searchInvoiceColumns: any[] =
    [
      {
        text: 'S.No', width: '5%', sortable: false, menu: false, cellsrenderer: function (row, cell, value) {
          return '<div style="text-align: center; margin-top: 10px;">' + (1 + row) + '</div>';
        }
      },
      { text: 'EmployeeID', datafield: 'EmployeeID', width: '5%', hidden: true },
      { text: 'Employee Code', datafield: 'EmpCode', width: '10%' },
      { text: 'Name', datafield: 'FullName', width: '70%' },
      { text: 'Branch', datafield: 'BranchName', width: '10%' },
      // { text: 'Invoice Date', datafield: 'InvoiceDate', width: '17%', cellsformat: "dd/MM/yyyy" },
      // { text: 'JobID', datafield: 'JobID', width: '30%', hidden:true },
      // { text: 'JobNo', datafield: 'JobNo', width: '35%' },
      // { text: 'Customer Name', datafield: 'CustomerName', width: '40%' },
      // { text: 'GSTType', datafield: 'GSTType', width: '30%', hidden:true },
      { text: 'isSelf', datafield: 'isSelf', width: '30%', hidden: true },
      // { text: 'ReportFileName', datafield: 'ReportFileName', width: '30%', hidden:true },
    ];

  searchInvoiceSource: any =
    {
      datatype: 'json',
      datafields: [
        { name: 'EmployeeID', type: 'int' },
        { name: 'EmpCode', type: 'string' },
        { name: 'FullName', type: 'string' },
        { name: 'BranchName', type: 'string' },
        // { name: 'InvoiceDate', type: 'date' },
        { name: 'isSelf', type: 'int' },
        // { name: 'JobNo', type: 'string' },
        // { name: 'GSTType', type: 'string' },
        // { name: 'Segment', type: 'string' },
        // { name: 'CustomerName', type: 'string' },
        // { name: 'ReportFileName', type: 'string' },
      ],
      id: 'invoiceid',
      localdata: ''
    };
  getGridData() {
    this.getData().then((list: any) => {
      this.searchInvoiceSource.localdata = list.result;
      this.searchInvoiceAdapter = new jqx.dataAdapter(this.searchInvoiceSource);
    });

  }
  getData() {
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.property.WebAPIipAndPort.concat(this.property.BSSAPI) + "/HR/LOV_EmployeeMaster?LoginID=" + this.property.loginID)
        .then((res: any) => {
          console.log('Response', res);
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }

  RowclickInvoiceSearch(event: any): void {
    var args = event.args;
    if (this.property.roleId == this.property.DefaultRoleId || this.property.userId == 33 || this.property.userId == 2311 || this.property.userId == 2224) {

      var selectedRowIndex = args.rowindex;
      this.searchItem.emit();
      args.row.bounddata.timestamp = new Date().getTime();
      console.log(args);
      this.router.navigate(['home/addemployee'], { queryParams: args.row.bounddata });
    } else if (args.row.bounddata.isSelf == 1) {
      //  var args = event.args;
      var selectedRowIndex = args.rowindex;
      this.searchItem.emit();
      args.row.bounddata.timestamp = new Date().getTime();
      console.log(args);
      this.router.navigate(['home/addemployee'], { queryParams: args.row.bounddata });
    }


  }
}
